import { NATIVE_CHAT_SURFACE_ATTRIBUTE } from '@ekhodealer/ekho-common';

/**
 * True when the host page renders the chat widget itself. Such a page owns both
 * the widget's DOM host and the `window.EkhoChat` global, so the SDK yields
 * rather than mounting a competing instance.
 */
export function hasNativeChatSurface(): boolean {
  return document.documentElement.hasAttribute(NATIVE_CHAT_SURFACE_ATTRIBUTE);
}
